import React from 'react';
import ActiveBooking from '../layout/ActiveBooking';

const App = () => {
  return (
    <>
      <ActiveBooking />
    </>
  );
};

export default App;
